import planetDescriptionChange from './actions/planetDescriptionChange';
import planetDescriptionCreate from './actions/planetDescriptionCreate';
import planetDescriptionDetail from './actions/planetDescriptionDetail';
import planetDescriptionList from './actions/planetDescriptionList';
import getPlanetDescription from './getters/getPlanetDescription';
import planetDescriptionUpload from './mutations/planetDescriptionUpload';

const actions = {
    planetDescriptionChange,
    planetDescriptionCreate,
    planetDescriptionDetail,
    planetDescriptionList
};

const mutations = {
    planetDescriptionUpload
};

const getters = {
    getPlanetDescription
};

export default { actions, mutations, getters };
